// extracted by mini-css-extract-plugin
module.exports = {"link":"contact-module--link--2Ghja"};